import React, { useState, useEffect } from "react"
import ReactLoading from "react-loading"
import styled from "styled-components"

import { Page, CenterArea, CenterStack, FloatingSpinner, InlineSubtitle } from "../styles"

const MESSAGE = "Fetching your data..."
const TYPING_INTERVAL_MS = 50

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
`

const LoadingSpinner: React.FC = () => {
  const [displayedText, setDisplayedText] = useState("")

  useEffect(() => {
    let index = 0
    const intervalId = setInterval(() => {
      if (index < MESSAGE.length) {
        setDisplayedText(MESSAGE.slice(0, index + 1))
        index++
      } else {
        clearInterval(intervalId)
      }
    }, TYPING_INTERVAL_MS)

    return () => clearInterval(intervalId)
  }, [])

  return (
    <Page>
      <div />
      <CenterArea>
        <CenterStack>
          <FloatingSpinner>
            <ReactLoading type="spin" color="#bbb" width={48} />
          </FloatingSpinner>
          <CenteredContent>
            <InlineSubtitle>{displayedText}</InlineSubtitle>
          </CenteredContent>
        </CenterStack>
      </CenterArea>
      <div />
    </Page>
  )
}

export default LoadingSpinner
